<template>
  <detra-modal :show="show_modal" @hide="hide()">
    <template slot="close-button-content">
      <div class="btn btn-danger btn-sm mr-2" v-if="task && task.project && this.$root.canEditBilledProjects(task.project.is_billed)" @click="unassign()">Unassign</div>
    </template>

    <div class="p-24">
      <div class="flex">
        <div class="heading-medium flex" style="padding-right: 10rem;">
          <skeleton-text :until="task">
            <div v-if="task">"{{ task.name }}" {{ _task_date }}</div>
          </skeleton-text>
        </div>
        <!--        <dot-button>-->
        <!--          <div class="dropdown-button" @click="editTask()">Edit task</div>-->
        <!--          <div class="dropdown-button" @click="deleteTask()">Delete task</div>-->
        <!--        </dot-button>-->
      </div>
      <div class="text-strong color-gray-500" v-if="task">Agenda assignment of {{ task.type === 'internal' ? 'internal' : 'client' }} task</div>
      <div class="mt-24 flex w-100">
        <div class="w-100 p-8">
          <div class="text-strong">Assignee</div>
          <div class="heading-small">
            <skeleton-text :until="task">
              <div v-if="task && task.user">{{ task.user.name }}</div>
            </skeleton-text>
          </div>
        </div>
        <div class="w-100 p-8">
          <div class="text-strong">Assigned hours</div>
          <div class="heading-small">
            <skeleton-text :until="task">
              <hour-edit field="duration" :show-raw="!(task && task.project && this.$root.canEditBilledProjects(task.project.is_billed))" allow-edit-null="true" v-if="task" :task="task"></hour-edit>
            </skeleton-text>
          </div>
        </div>
        <div class="w-100 p-8">
          <div class="text-strong">Completed hours</div>
          <div class="heading-small">
            <skeleton-text :until="task">
              <hour-edit field="engineering_hours" :show-raw="!(task && task.project && this.$root.canEditBilledProjects(task.project.is_billed))" v-if="task" :task="task"></hour-edit>
            </skeleton-text>
          </div>
        </div>
      </div>
      <div>
        <div class="mt-24 flex" v-if="!show_done_for_this_day">
          <button class="btn btn-secondary mr-8 w-100" @click="goToTaskDetails()" v-skeleton-button="!task">Go to task details</button>
          <button class="btn btn-jet ml-8 w-100" @click="toggleDoneForThisDayForm(true)" v-show="!task || (task && !task.done)" v-if="task && task.project && $root.canEditBilledProjects(task.project.is_billed)" v-skeleton-button="!task">Done for this day</button>
          <button class="btn btn-jet ml-8 w-100" @click="undoneTask()" v-show="!task || (task && task.done)" v-if="task && task.project && $root.canEditBilledProjects(task.project.is_billed)" v-skeleton-button="!task">Mark as undone</button>
        </div>
        <div class="flex mt-24 align-items-center w-100" v-if="show_done_for_this_day">
          <div class="w-100 p-8">
            <div class="btn btn-silent w-100" @click="toggleDoneForThisDayForm(false)">Cancel</div>
          </div>
          <div class="w-100 p-8">
            <div class="text-strong">Hours worked</div>
            <div class="mt-1 flex align-items-center">
              <input type="text" v-model="hours_worked" class="form-control">
            </div>
            <div class="mt-1 flex align-items-center">
              <input type="checkbox" v-model="entire_task_done"><span class="ml-1">Entire task is done</span>
            </div>
          </div>
          <div class="w-100 p-8">
            <div class="btn btn-jet w-100" @click="done()">Done</div>
          </div>
        </div>
      </div>

      <div class="divider mt-24"></div>
      <skeleton-text :until="task" :block="true">
        <div class="mt-24">
          <div class="heading-medium mb-3">Description</div>
          <div class="text-strong" v-if="task">{{ task.description || 'No description.' }}</div>
        </div>
      </skeleton-text>

      <div class="divider mt-24"></div>

      <div class="mt-24">
        <div class="heading-medium mb-24">Task comments</div>
        <skeleton-text :until="task" :block="true">
          <div v-if="task && task.comments.length > 0">
            <div v-for="comment in task.comments" v-if="comment.log === 0">
              <div class="mt-3">
                <span class="heading-small">{{ comment.user.name }}</span>
                <span class="text-strong color-gray-500">{{ comment.created_at_human }}</span>
              </div>
              <div>{{ comment.comment }}</div>
            </div>
          </div>
        </skeleton-text>
        <div class="flex mt-16">
          <input @keyup.enter="postComment()"
                 v-model="comment_text"
                 type="text"
                 class="form-control flex-grow-1 mr-4"
                 placeholder="Add comment..."
                 v-skeleton-input="!task"
          >
          <button class="btn btn-secondary" @click="postComment()" v-skeleton-button="!task">Post</button>
        </div>
      </div>
    </div>
  </detra-modal>
</template>
<script>
import DotButton from '../../../components/dot-button'
import HourEdit from './hour-edit.vue'

export default {
  components: {
    DotButton,
    HourEdit,
  },
  created() {
    this.$root.$on('SmallTaskModal::show', ({task_id, row, col}) => {
      this.task = null
      this.col = null
      this.row = null
      this.show()
      this.axios.get('/n/tasks/' + task_id + '?simple=true').then(response => {
        this.task = response.data.data
        this.row = row
        this.col = col
      })
    })
  },
  data() {
    return {
      task: null,
      row: null,
      col: null,
      show_modal: false,
      comment_text: null,
      show_done_for_this_day: false,
      hours_worked: null,
      entire_task_done: null,
    }
  },
  computed: {
    _task_date() {
      return this.task ? moment(this.task.date).format("Y-MM-DD (dddd)") : null
    }
  },
  methods: {
    show() {
      this.show_modal = true
      this.show_done_for_this_day = false
      this.entire_task_done = false
    },
    hide() {
      this.show_modal = false
    },
    postComment() {
      if (!this.comment_text || this.comment_text == '') return

      this.axios.post('/n/tasks/' + this.task.id + '/comment', {
        comment: this.comment_text,
      }).then(response => {
        let comment = response.data.data
        comment.log = 0
        this.task.comments.push(comment)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.comment_text = null
      })
    },
    toggleDoneForThisDayForm(show) {
      this.show_done_for_this_day = show
      if (show) {
        this.hours_worked = this.$root.formatIntegerSecondsToReadable(this.task.duration)
      }
      if (!show) {
        this.hours_worked = null
      }
    },
    done() {
      this.axios.post('/n/tasks/' + this.task.id + '/done', {
        hours_worked: this.hours_worked,
        entire_task_done: this.entire_task_done,
      }).then(response => {
        let tasks = response.data.data
        _.each(tasks, task => {
          this.$root.$emit('Tasks::updated', {task})
        })
        this.hide()
      })
    },
    undoneTask() {
      this.axios.post('/n/tasks/' + this.task.id + '/undone').then(response => {
        let tasks = response.data.data
        _.each(tasks, task => {
          this.$root.$emit('Tasks::updated', {task})
        })
        this.hide()
      })
    },
    goToTaskDetails() {
      this.$root.$emit('TaskModal::show-task', {task_id: this.task.parent_id, row: this.row, col: this.col, callback: () => this.hide()})
    },
    editTask() {
      this.$root.$emit('TaskModal::edit-task', {task_id: this.task.id, row: this.row, col: this.col}, () => {
        this.hide()
      })
    },
    deleteTask() {
      if (!confirm('Are you sure?')) return

      this.axios.delete('/n/tasks/' + this.task.id).then(response => {
        this.$root.$emit('Tasks::deleted', {task: this.task})
        this.hide()
      }).catch(err => {
        console.log(err)
      })
    },
    unassign() {
      if (!confirm('Are you sure?')) return
      this.axios.post('/n/tasks/unassign', {tasks: [this.task.id]}).then(response => {
        this.hide()
        _.each(response.data.data, task => {
          this.$root.$emit('Tasks::deleted', {task})
        })
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/small-task-modal/small-task-modal.vue